( function( global, $ ) {

    var $nav = $('[gr-nav]'),
        $navHeight = $nav.outerHeight(),
        $search = $('[gr-search]'),
        $searchTrigger = $('[gr-search-trigger]'),
        $navShadow = $('[data-nav-shadow]');

        
    $(window).on('wheel', global.methods.debounce(function(e) {
        var delta = e.originalEvent.deltaY;
        
        if ($(window).scrollTop() > $navHeight && delta > 0 && !$nav.hasClass('is-hidden')) {
            $nav.addClass('is-hidden');
        } else if (delta < 0 && $nav.hasClass('is-hidden')) {
            $nav.removeClass('is-hidden');
        }
    }));
        
    $searchTrigger.on('click', function(e) {
        e.preventDefault();
        
        if (!global.methods.isMobile('breakpoint', 'md')) {
            if ($search.attr('gr-search') === 'active') {
                $search.attr('gr-search', '');
            } else {
                global.methods.toggleAttributeValue($search[0], 'gr-search', 'active', true);
                $search.find('input[type="search"]').focus();
            }
        }
    });
        
    if($navShadow) {
        var $navShadowHeight = $navShadow.outerHeight();
        $(window).on('scroll', global.methods.debounce(function() {    
            if ($(window).scrollTop() > $navShadowHeight && !$navShadow.hasClass('h-shadow-xs')) {
                $navShadow.addClass('h-shadow-xs');
            } else if ($(window).scrollTop() <= $navShadowHeight && $navShadow.hasClass('h-shadow-xs')) {
                $navShadow.removeClass('h-shadow-xs');
            }
        }, 50));
    }

}( window.groots, jQuery ));
